import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { InfoWidgetProps } from 'containers/Widgets/InfoWidget/InfoWidget'
import { PartToWholeWidgetProps } from 'containers/Widgets/PartToWholeWidget/PartToWholeWidget'
import { RankWidgetProps } from 'containers/Widgets/RankWidget/RankWidget'
import { WidgetDateFilter } from 'containers/Widgets/types'
import axiosBaseQuery from 'services/axiosBaseQuery'
import i18n from 'utils/i18n'

export type WidgetModule = 'ops'

export type WidgetSubmodule = 'route' | 'task' | 'service_point'

export type WidgetType =
  | 'average_distance'
  | 'average_time_spent_per_route'
  | 'average_fuel_consumption_per_route'
  | 'route_status'
  | 'average_time_spent_per_task'
  | 'top_ranked_sp_created_task'

export const widgetsApi = createApi({
  reducerPath: 'widgetsApi',
  tagTypes: [],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_BASE_URL}/widget/api/v1`,
  }),
  endpoints: (builder) => ({
    getWidgetInfo: builder.query<
      Required<InfoWidgetProps['data']>,
      {
        clientId: number
        module: string
        submodule: string
        widget: string
        period: WidgetDateFilter
        historic?: boolean
      }
    >({
      query: ({ clientId, module, submodule, widget, period, historic }) => ({
        url: `/${module}/${submodule}/${widget}`,
        method: 'GET',
        params: {
          client_id: clientId,
          period,
          limit: 5,
          historic,
        },
        headers: {
          'Accept-Language': i18n.language,
        },
        errorOverride: true,
      }),
      providesTags: [],
    }),
    getWidgetRank: builder.query<
      Required<RankWidgetProps['data']>,
      {
        clientId: number
        module: string
        submodule: string
        widget: string
        period: WidgetDateFilter
      }
    >({
      query: ({ clientId, module, submodule, widget, period }) => ({
        url: `/${module}/${submodule}/${widget}`,
        method: 'GET',
        params: {
          client_id: clientId,
          period,
          limit: 5,
        },
        headers: {
          'Accept-Language': i18n.language,
        },
        errorOverride: true,
      }),
      providesTags: [],
    }),
    getWidgetPTW: builder.query<
      Required<PartToWholeWidgetProps['data']>,
      {
        clientId: number
        module: string
        submodule: string
        widget: string
        period: WidgetDateFilter
      }
    >({
      query: ({ clientId, module, submodule, widget, period }) => ({
        url: `/${module}/${submodule}/${widget}`,
        method: 'GET',
        params: {
          client_id: clientId,
          period,
          limit: 5,
        },
        headers: {
          'Accept-Language': i18n.language,
        },
        errorOverride: true,
      }),
      providesTags: [],
    }),
  }),
})

export const { useGetWidgetInfoQuery, useGetWidgetRankQuery, useGetWidgetPTWQuery } = widgetsApi
